import { FC, PropsWithChildren } from 'react';

import { NotificationMenu, Comparison, Layout, Playback, Tags, Visualizer3d } from '@blocks';
import { Box, ElvaLogoName, u } from '@ui';

import { LINKS } from '../../utils/routes';

import { ClubPropertyControl } from './ClubPropertyControl';
import * as css from './Navigation.css';
import { MenuLabel, NavigationMenu } from './NavigationMenu';

const Logo = () => {
    return (
        <div className={css.logo}>
            <ElvaLogoName />
        </div>
    );
};

const ActivitySetupActionGroup = () => {
    return (
        <div className={css.actionGroupLayout}>
            <ClubPropertyControl />
            <Tags url={LINKS.getTags} />
            <Layout url={LINKS.getLayoutEditor} />
            <Comparison />
        </div>
    );
};

const ActivityNavigationControls = () => {
    return (
        <>
            <li className={css.action}>
                <Visualizer3d url={LINKS.getVisualizer3d} />
            </li>
            <li className={css.action}>
                <Playback url={LINKS.getPlayback} />
            </li>
            <li>
                <NotificationMenu getLinkToSwing={LINKS.getFullActivity} />
            </li>
        </>
    );
};
const UserMenu = () => {
    return (
        <li>
            <div className={css.menuButton}>
                <MenuLabel />
                <NavigationMenu />
            </div>
        </li>
    );
};

export const Navigation: FC<PropsWithChildren<{ isActivity?: boolean; isSwing?: boolean }>> = ({
    isActivity,
    isSwing,
    children,
}) => {
    return (
        <div className={css.root}>
            <Box
                display="flex"
                flexWrap="wrap"
                gap={{ xs: u(1), md: u(2) }}
                justifyContent="space-between"
                alignItems="center"
            >
                <Logo />
                {isActivity && <ActivitySetupActionGroup />}
                <ul className={css.buttons}>
                    {isSwing && <ActivityNavigationControls />}
                    <UserMenu />
                </ul>
            </Box>
            {children}
        </div>
    );
};
